import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {RootState } from "../../Core/Store";
import { defaultDateStrings } from "../../Common/Constants";
import { startAppListening } from "../../Core/listenerMiddleware";
import { useLocation } from 'react-router-dom';
import { fetchAlarmDatas, fetchAlarmDatasWithScope } from "../../Alarms/Slice";
import { push } from 'react-router-redux';
import { isEqual, update } from "lodash";
import { fetchMachineTimes } from "../../MachineTimes/slice";
import { fetchVeryShortCount } from "../../RunningPeriodsCount/countSlice";
import Format from "../Util_methods/formatParamOptions";

export interface Params{
    start:string;
    end:string;
    bucketSize:"y" | "M" | "w" | "d"
    calendarSize:"Year" | "Month"
    country:string;
    customerID:string;
    deviceTypes: number[];
    devicesWithSerial: string[];
    cadid:number|string
    scope: string;
    alarmText:string;
}

export const initialState: Params = {
    start:defaultDateStrings.start,
    end:defaultDateStrings.end,
    bucketSize:"y",
    calendarSize:"Year",
    country:null,
    customerID:null,
    deviceTypes:[],
    devicesWithSerial: [],
    cadid:null,
    scope: "customer",
    alarmText:null
};





const paramSlice = createSlice({
  name: "params",
  initialState,
  reducers: {
      updateParams: (state, action: PayloadAction<any>) => {
          if(action.payload === null){
            return initialState
          }
          return action.payload
      },
  }
});

export const { updateParams } = paramSlice.actions;

export const getParamsSelector = (state: RootState) => state.params;

export default paramSlice.reducer;





